import { DownloadRounded as DownloadRoundedIcon } from '@mui/icons-material'
import { TabContext, TabList, TabPanel } from '@mui/lab'
import { Box, Container, FormControlLabel, IconButton, Stack, Switch, Tab, Typography } from '@mui/material'
import { t } from 'i18next'
import { useEffect, useState } from 'react'

import { useGlobalContext } from '../../Shared/Contexts/GlobalContext'
import { useStatistics } from '../Contexts/StatisticsContext'
import Filters from '../Filters/Filters'
import RootOrganizationTable from '../Tables/RootOrganizationTable'
import SingleOrganizationTable from '../Tables/SingleOrganizationTable'

const Statistics = () => {
  const { dateRange } = useGlobalContext()
  const { useExportStatistics } = useStatistics()
  const [useCalendar, setUseCalendar] = useState(false)

  const [activeTab, setActiveTab] = useState('single-org')

  const [filters, setFilters] = useState({})

  const handleFiltersChange = (filters) => useCalendar ? setFilters({ ...filters, dateRange }) : setFilters({ ...filters, dateRange: null })

  const handleChange = (_event, value) => setActiveTab(value)

  const handleExportStatistics = () => useExportStatistics({ payload: filters })


  useEffect(() => {
    useCalendar ? setFilters({ ...filters, dateRange }) : setFilters({ ...filters, dateRange: null })
  }, [useCalendar, dateRange])

  const handleUseCalendarChange = (event) => setUseCalendar(event.target.checked)

  return (
    <>
      <Container
        maxWidth="lg"
        sx={{ py: 3 }}>
        <Stack direction={'row'} justifyContent="space-between" alignItems="center">
          <Typography variant="h2">Statistiche</Typography>
          <IconButton
            id="download-statistics-button"
            aria-label={t('statistics.download')}
            onClick={handleExportStatistics}>
            <DownloadRoundedIcon />
          </IconButton>
        </Stack>
        <Stack direction={'row'} spacing={2} sx={{ mt: 2 }}>
          <Filters
            onChange={handleFiltersChange}
            filters={filters}
          />
          <FormControlLabel
            control={
              <Switch
                checked={useCalendar}
                value={useCalendar}
                onChange={handleUseCalendarChange}
              />
            }
            label={'Usa calendario'}
            labelPlacement="end"
          />
        </Stack>
        <TabContext value={activeTab}>
          <Box
            sx={{
              marginTop: 4,
              borderBottom: 1,
              borderColor: 'divider'
            }}>
            <TabList
              onChange={handleChange}
              aria-label="statistics">
              <Tab
                aria-label={`tab-${t('statistics.singleOrg')}`}
                label={'Singole organizzazioni'}
                value="single-org"
                data-testid="tab-statistics-single"
              />
              <Tab
                aria-label={`tab-${t('statistics.groupRoot')}`}
                label={'Raggruppate per root'}
                value="root"
                data-testid="tab-statistics-root"
              />
            </TabList>
          </Box>
          <TabPanel
            value="single-org"
            sx={{ px: 0 }}>
            <SingleOrganizationTable filters={filters} />
          </TabPanel>
          <TabPanel
            value="root"
            sx={{ px: 0 }}>
            <RootOrganizationTable filters={filters} />
          </TabPanel>
        </TabContext>
      </Container>
    </>
  )
}

export default Statistics
